import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const appRoutes: Routes = [
  {
    path: 'ctv/:appid/:region/:device',
    loadChildren: () =>
      import('./ctv-details/ctv-details.module').then(m => m.CtvDetailsModule)
  },
  {
    path: 'apps/:appid/:region/:os/:device',
    loadChildren: () =>
      import('./app-details/app-details-module').then(m => m.AppDetailsModule)
  },
  {
    path: 'domains/:domain/:region/:device',
    loadChildren: () =>
      import('./domain-details/domain-details.module').then(
        m => m.DomainDetailsModule
      )
  },
  {
    path: 'sellers/:sellerid/:type/:region',
    loadChildren: () =>
      import('./seller-details/seller-details.module').then(
        m => m.SellerDetailsModule
      )
  },
  {
    path: '**',
    redirectTo: '/rankings'
  }
];

export const appRoutingProviders: any[] = [];

export const routing: ModuleWithProviders<any> =
  RouterModule.forChild(appRoutes);
